module.exports = {
  API_HOST: process.env.VUE_APP_API_HOST || "localhost",
  API_PORT: process.env.VUE_APP_API_PORT,
  BASE_URL: process.env.VUE_APP_BASE_URL || "/",
};
